var _linearGradient, _linearGradient2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsAutomationBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DevOpsAutomationBuild",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0lnujhj8ha",
    x1: -1758.706,
    y1: -2070.713,
    x2: -1752.259,
    y2: -2070.713,
    gradientTransform: "matrix(1 0 0 -1 1760.974 -2061.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "zdgak0mh4c",
    x1: 0,
    y1: 32,
    x2: 32,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a56eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0f62fe"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "fgrlcqaukb",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.527 21.468-6.886-6.886a9.89 9.89 0 0 0 .35-2.579c0-5.514-4.486-10-10-10a9.932 9.932 0 0 0-5.509 1.663l6.923 6.923a2 2 0 1 1-2.828 2.828L3.654 6.494a9.942 9.942 0 0 0-1.663 5.509c0 5.514 4.486 10 10 10 .893 0 1.755-.127 2.579-.35l6.885 6.885C22.43 29.513 23.71 30 24.991 30s2.561-.487 3.536-1.462c.944-.944 1.464-2.199 1.464-3.535s-.52-2.591-1.464-3.535zm-1.414 5.656a3 3 0 0 1-4.243 0l-7.756-7.756a7.946 7.946 0 0 1-3.122.635c-4.411 0-8-3.589-8-8 0-.715.1-1.406.279-2.065l4.893 4.893c.755.756 1.76 1.172 2.828 1.172s2.073-.416 2.828-1.172c.755-.755 1.172-1.76 1.172-2.828s-.417-2.073-1.172-2.828L9.927 4.282a7.862 7.862 0 0 1 2.065-.279c4.411 0 8 3.589 8 8a7.963 7.963 0 0 1-.635 3.122l7.757 7.757a3 3 0 0 1 0 4.242z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 5.492 9.554)",
    style: {
      fill: "url(#0lnujhj8ha)",
      strokeWidth: 0
    },
    d: "M2.268 5.054h6.447v9H2.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0
    },
    d: "m10.992 7-2 2-3-.23V1h6v5l-1 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#fgrlcqaukb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#zdgak0mh4c)",
      strokeWidth: 0
    },
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.992,
    cy: 4,
    r: 3,
    style: {
      fill: "#001d6c",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsAutomationBuild);
export default __webpack_public_path__ + "static/media/DevOpsAutomationBuild.4961c352ad16c82b4f40dca16a3b1ce5.svg";
export { ForwardRef as ReactComponent };